export default __webpack_public_path__ + "static/media/soustitre3.0621004c.jpeg";